import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import i18n from './i18n'

// Vuetify
import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import { aliases, mdi } from 'vuetify/iconsets/mdi'
import '@mdi/font/css/materialdesignicons.css'

// Custom theme for historical archive
const archiveTheme = {
  dark: false,
  colors: {
    primary: '#8B0000', // Dark red - symbolizing historical significance
    secondary: '#4B4B4B', // Dark gray - for solemnity
    accent: '#B8860B', // Dark goldenrod - for historical documents
    background: '#F5F5F5', // Light gray background
    surface: '#FFFFFF',
    error: '#B71C1C',
    info: '#2196F3',
    success: '#4CAF50',
    warning: '#FB8C00',
  }
}

// Create Vuetify instance
const vuetify = createVuetify({
  components,
  directives,
  icons: {
    defaultSet: 'mdi',
    aliases,
    sets: {
      mdi,
    },
  },
  theme: {
    defaultTheme: 'archiveTheme',
    themes: {
      archiveTheme,
    },
  },
})

// Add custom styling
import './assets/styles.css'

// Import authentication service
import AuthService from './services/AuthService'

// Initialize authentication state
AuthService.initAuth()

const app = createApp(App)

// Use plugins
app.use(router)
app.use(vuetify)
app.use(i18n)

app.mount('#app')
